import React, {Component} from "react";

import "./DocumentUploadingTab.css";
import {Col, Row, Select, message, Typography, Upload, Icon, Spin} from "antd";
import UploadWrapper from "./UploadWrapper";
import {displayError, displayGenericError} from "../common/notifications";
import {deleteOrderAttachedFile, uploadInvoice} from "../api/api";
import withUseIntl from "components/withUseIntl";

import "./DocumentIndividualUploadingTab.scss"
import 'react-day-picker/lib/style.css';
import UploadWrapperMulti from "./UploadWrapperMulti";
import {ReactComponent as UploadIcon} from "../assets/icons/upload-icon.svg";
import {FormattedMessage} from "react-intl";
import UploadWrapperDisplay from "./UploadWrapperDisplay";

const {Title, Text, Paragraph} = Typography;
const { Dragger } = Upload;

class DocumentOrderUploading extends Component {
    state = {
        documents: this.props.documents || [],
        isSubmitted: false,
        file:null,
        selectedType:null,
        uploading:false
    }

    constructor(props) {
        super(props);
        const intl = props.useIntl;
        this.listDocs = [
            {
             value:'PAYMENT_INVOICE',
             label: `${intl.formatMessage({id: "app.modal.order.document.payment.invoice"})}`
            },{
                value:'COMMERCIAL_AGREEMENT',
                label: `${intl.formatMessage({id: "app.modal.order.document.commercial.agreement"})}`
            },{
                value:'LOGISTICS_DOCUMENTATION',
                label: `${intl.formatMessage({id: "app.modal.order.document.logistics.documentation"})}`
            },{
                value:'CUSTOMS_DECLARATION',
                label: `${intl.formatMessage({id: "app.modal.order.document.payment.customsdeclaration"})}`
            },{
                value:'PAYMENT_SLIP',
                label: `${intl.formatMessage({id: "app.modal.order.document.payslips"})}`
            },{
                value:'OTHER',
                label: `${intl.formatMessage({id: "app.modal.order.document.others"})}`
            }
        ];
    }


    handleUpload = (info)  => {
        console.log(info);
        let { file, type, index, fileList,status, onSuccess, onProgress} = info;
        this.setState({
            uploading:true
        })
        const order = this.props.order;
        uploadInvoice({id: order.id, fileType: this.state.selectedType,
            remarks: this.state.selectedType,file:file,otherTypeDescription: "", onSuccess: onSuccess,
        })
            .then(res => {
                let newRes = [];
                res.forEach(item => {
                    if(item.size) item.size = item.size/1024;
                    newRes.push(item);
                });
                this.setState({
                    documents: newRes,
                    uploading:false
                });
            })
            .catch((e) => {
                this.setState({
                    uploading:false
                });
                displayError(e.message)
            });
    };

    handleRemoveFile = ({id, type}) => {
        const orderId = this.props.order.id;
        deleteOrderAttachedFile(orderId,id)
            .then(() => {
                    let {documents} = this.state;
                    documents = documents.filter(item => item.id != id);
                    this.setState({documents});
            })
            .catch(displayGenericError);
    };
    handleCorporateSubmit = (onboardingType, dateSelect, timeSelect) => {
        this.props.updateOnboardingForm({
            dateSelect: dateSelect,
            timeSelect: timeSelect,
            onboardingType: onboardingType,

        })
    }
    handleSubmit = () => {
        this.props.updateOnboardingForm({
            dateSelect:this.state.dateSelect,
            timeSelect: this.state.selectTime,
            onboardingType:this.state.documentType,
            documents:this.state.documents

        })
      //  this.props.handleSubmit(false);
    }

    onChange = val => {
        this.setState({
            selectedType: val
        })
    }

    handleBeforeUpload = file => {
        const intl = this.props.useIntl;
        const isUnderLimit = file.size / 1024 / 1024 < 10; // < 10MB

        if (!isUnderLimit) {
            displayGenericError({
                message: "File size must be smaller than 10MB"
            });
        } else {
            if (this.state.selectedType === 'CUSTOMS_DECLARATION') {
                let customsdeclaration = this.state.documents.filter(item => item['attachedFileType'] == "CUSTOMS_DECLARATION");
                if (customsdeclaration.length >= 2) {
                    displayError(intl.formatMessage({id: "app.modal.documentorderuploading.limit.upload.document"}));
                    return false;
                }

            } else if (this.state.selectedType === 'PAYMENT_INVOICE') {
                let paymentInvoice = this.state.documents.filter(item => item['attachedFileType'] == "PAYMENT_INVOICE");
                if (paymentInvoice.length >= 2) {
                    displayError(intl.formatMessage({id: "app.modal.documentorderuploading.limit.upload.document"}));
                    return false;
                }
            } else if (this.state.selectedType === 'COMMERCIAL_AGREEMENT') {
                let commercialAgreement = this.state.documents.filter(item => item['attachedFileType'] == "COMMERCIAL_AGREEMENT");
                if (commercialAgreement.length >= 2) {
                    displayError(intl.formatMessage({id: "app.modal.documentorderuploading.limit.upload.document"}));
                    return false;
                }
            } else if (this.state.selectedType === 'LOGISTICS_DOCUMENTATION') {
                let logisticsDocs = this.state.documents.filter(item => item['attachedFileType'] == "LOGISTICS_DOCUMENTATION");
                if (logisticsDocs.length >= 2) {
                    displayError(intl.formatMessage({id: "app.modal.documentorderuploading.limit.upload.document"}));
                    return false;
                }
            } else if (this.state.selectedType === 'PAYMENT_SLIP') {
                let paymentSplip = this.state.documents.filter(item => item['attachedFileType'] == "PAYMENT_SLIP");
                if (paymentSplip.length >= 2) {
                    displayError(intl.formatMessage({id: "app.modal.documentorderuploading.limit.upload.document"}));
                    return false;
                }
            } else if (this.state.selectedType === 'OTHER') {
                let other = this.state.documents.filter(item => item['attachedFileType'] == "OTHER");
                if (other.length >= 2) {
                    displayError(intl.formatMessage({id: "app.modal.documentorderuploading.limit.upload.document"}));
                    return false;
                }
            }
        }
        return isUnderLimit;
    };

    render() {
        const {isSubmitted} = this.state;
        const intl = this.props.useIntl;
        let customsdeclaration = this.state.documents.filter(item => item['attachedFileType'] == "CUSTOMS_DECLARATION");
        let paymentInvoice = this.state.documents.filter(item => item['attachedFileType'] == "PAYMENT_INVOICE");
        let commercialAgreement = this.state.documents.filter(item => item['attachedFileType'] == "COMMERCIAL_AGREEMENT");
        let logisticsDocs = this.state.documents.filter(item => item['attachedFileType'] == "LOGISTICS_DOCUMENTATION");
        let paymentSplip = this.state.documents.filter(item => item['attachedFileType'] == "PAYMENT_SLIP");
        let other = this.state.documents.filter(item => item['attachedFileType'] == "OTHER");
        let centerStyle = {width: "100%", verticalAlign: "middle", marginLeft: "15px", marginRight: "15px", paddingTop:"10px"};
        return (
            <div className="general-info-tab">
                <div className="left-pane" style={{paddingTop: 10}}>
                        <div className="upload-wrapper">
                    <Row gutter={24}>
                        <Col md={14}>
                            <p><b>{intl.formatMessage({id: "app.modal.documentorderuploading.select.document"})}</b></p>
                            <Select
                                showSearch
                                placeholder={intl.formatMessage({id: "app.common.select"})}
                                style={{width: 300, ...this.props.style}}
                                optionFilterProp="children"
                                onChange={this.onChange}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                mode={this.props.mode || "default"}
                            >
                                {this.listDocs.map(item => {
                                    return (<Select.Option value={item.value}>{item.label}</Select.Option>);
                                })}
                            </Select>
                        </Col>
                        <Col md={10} style={{cursor: "pointer", marginTop: "10px"}}>
                            {this.state.selectedType ? (
                                <>
                            <Upload
                                accept={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                                beforeUpload={this.handleBeforeUpload}
                                name="file"
                                disabled={this.state.selectedType == null}
                                customRequest={this.handleUpload}
                                showUploadList={false}
                            >
                                {this.state.uploading ? <Spin style={centerStyle}/> : <UploadIcon style={centerStyle}/>}
                                <div style={{marginTop: "3px", marginLeft: "15px", marginRight: "15px"}}>
                                    <Text style={{fontSize: "13px"}}><FormattedMessage
                                        id="app.modal.uploadwrapper.dragyourfile"/></Text>
                                </div>
                            </Upload>
                                </>): null}
                        </Col>
                    </Row>
                        </div>
                    <Row gutter={24}>
                        <Col md={24}>
                            {paymentInvoice.length > 0 ? <UploadWrapperDisplay
                                files={paymentInvoice}
                                title={intl.formatMessage({id: "app.modal.order.document.payment.invoice"})}
                                type="PAYMENT_INVOICE"
                                isOriginatorAttachedFile={false}
                                fileExtension={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                                handleRemoveFile={this.handleRemoveFile}
                                disabled={isSubmitted}
                                isOrderFile={true}
                            /> : null}
                        </Col>
                    </Row><Row gutter={24}>
                    <Col md={24}>

                        {commercialAgreement.length > 0 ? <UploadWrapperDisplay
                            files={commercialAgreement}
                            title={intl.formatMessage({id: "app.modal.order.document.commercial.agreement"})}
                            type="COMMERCIAL_AGREEMENT"
                            handleRemoveFile={this.handleRemoveFile}
                            isOriginatorAttachedFile={false}
                            fileExtension={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                            disabled={isSubmitted}
                            isOrderFile={true}
                        /> : null}
                    </Col>
                </Row><Row gutter={24}>
                    <Col md={24}>
                        {logisticsDocs.length > 0 ? <UploadWrapperDisplay
                            files={logisticsDocs}
                            title={intl.formatMessage({id: "app.modal.order.document.logistics.documentation"})}
                            type="LOGISTICS_DOCUMENTATION"
                            handleRemoveFile={this.handleRemoveFile}
                            disabled={isSubmitted}
                            fileExtension={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                            isOrderFile={true}
                        /> : null}
                    </Col>
                </Row><Row gutter={24}>
                    <Col md={24}>
                        {customsdeclaration.length > 0 ? <UploadWrapperDisplay
                            files={customsdeclaration}
                            title={intl.formatMessage({id: "app.modal.order.document.payment.customsdeclaration"})}
                            type="CUSTOMS_DECLARATION"
                            isOriginatorAttachedFile={false}
                            fileExtension={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                            handleRemoveFile={this.handleRemoveFile}
                            disabled={isSubmitted}
                            isOrderFile={true}
                        /> : null}
                    </Col>
                </Row><Row gutter={24}>
                    <Col md={24}>
                        {paymentSplip.length > 0 ?
                            <UploadWrapperDisplay
                                files={paymentSplip}
                                title={intl.formatMessage({id: "app.modal.order.document.payslips"})}
                                type="PAYMENT_SLIP"
                                handleRemoveFile={this.handleRemoveFile}
                                disabled={isSubmitted}
                                fileExtension={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                                isOrderFile={true}
                            /> : null}
                    </Col>
                </Row><Row gutter={24}>
                    <Col md={24}>
                        {other.length > 0 ?
                            <UploadWrapperDisplay
                                files={other}
                                title={intl.formatMessage({id: "app.modal.order.document.others"})}
                                type="OTHER"
                                handleRemoveFile={this.handleRemoveFile}
                                disabled={isSubmitted}
                                fileExtension={".pdf,.png,.jpg,.jpeg,.bmp,.doc,.docx,image/*"}
                                isOrderFile={true}
                            /> : null}
                    </Col>
                </Row>
                </div>
            </div>
        )
    }

}


export default withUseIntl(DocumentOrderUploading);
